import { call } from 'redux-saga/effects'

import { mainFields } from 'core/service-wrapper/partner-api/handler-request/service-field-main'

export const partnerApiSubmitValidation = {
  fromESubmissionForCreate: function*(eSubPayload, user) {
    const [seller] = yield call(mainFields.sellerForEsub, user, eSubPayload)

    return {
      usePartnerApi: true,
      eSubPayload: eSubPayload,
      data: {
        sellerInformation: [seller],
      },
    }
  },

  fromESubmissionForUpdate: function*(eSubPayload, user, policyId) {
    const [seller] = yield call(mainFields.sellerForEsub, user, eSubPayload)
    return {
      usePartnerApi: true,
      eSubPayload: eSubPayload,
      data: {
        policyNumber: policyId,
        sellerInformation: [seller],
      },
    }
  },
}
